import type { RateSeniorityLevelDto } from '@/api/operational-view-client';

// =============================================================================
// operational-view-labels.ts — Habillage i18n des pages Profils & Fournisseurs (§2.5 v2.2).
// =============================================================================
// S14-bis : le modèle 4 codes couleurs Admin (et les sévérités d'alerte) ont été RETIRÉS avec l'ancienne
// « Vue opérationnelle ». Ne subsistent que les helpers PURS d'affichage encore consommés (niveaux de
// séniorité + format euros) — par les nouvelles pages ET par campaign-analysis-screen. Aucune règle métier.

/** Niveaux de séniorité (ordre d'affichage colonne, croissant). */
export const SENIORITY_LEVELS_ORDERED: readonly RateSeniorityLevelDto[] = [
  'Debutant',
  'Maitrisant',
  'Expert',
  'Referent',
];

/** Niveau de séniorité (ASCII API) → libellé FR accentué (i18n front). */
const SENIORITY_LABELS: Record<RateSeniorityLevelDto, string> = {
  Debutant: 'Débutant',
  Maitrisant: 'Maîtrisant',
  Expert: 'Expert',
  Referent: 'Référent',
};

/** Libellé FR d'un niveau de séniorité. */
export function seniorityLabel(level: RateSeniorityLevelDto): string {
  return SENIORITY_LABELS[level];
}

/** Formate un montant entier en euros (ou « — » si null). */
export function formatEur(value: number | null): string {
  return value === null ? '—' : `${String(value)} €`;
}

// -----------------------------------------------------------------------------
// Aide contextuelle « Hors Jeux » (DBU v2.7 §2.5 / UX v1.2 §7.3, ADR-HORS-JEUX-MEDIANE-TARGET-PRICE-PULSE-01).
// -----------------------------------------------------------------------------
// Textes d'habillage SEULEMENT : le flag est calculé par l'API (TJM > médiane du couple × (1 + seuil)),
// l'UI ne recalcule rien. Le seuil est un paramètre global (défaut 30 %) que l'UI ne lit pas : on le
// nomme « seuil » et on rappelle sa valeur par défaut. La médiane est une référence MOBILE pendant le
// cycle (spec §2.5) : la mention est portée là où le Hors Jeux est expliqué. Le Prix Cible est un repère.

/** Sous-libellé court des indicateurs « TJM hors jeu » / « Cellules Hors Jeux ». */
export const HORS_JEUX_HINT =
  'Au-dessus de la médiane actuelle du couple + seuil (30 % par défaut)';

/** Explication complète du flag, pour les descriptions de sections d'analyse. */
export const HORS_JEUX_EXPLANATION =
  'Hors Jeux : TJM au-dessus de la médiane du couple Profil × Niveau majorée du seuil paramétré (30 % par défaut). La médiane est calculée sur les réponses soumises et évolue pendant le cycle. Le Prix Cible reste un repère, sans effet sur ce flag.';
